// Modules
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cx from 'classnames';
// Styles
import * as styles from './Drawer.scss';

class Drawer extends Component {
  constructor(props) {
    super(props);
    this.drawer = null;

    this.state = {
      isReady: false
    };
  }

  componentDidMount() {
    this.animationId = requestAnimationFrame(() => {
      this.setState({ isReady: true });
    });
  }

  componentWillReceiveProps(newProps) {
    const { isOpen, locale } = newProps;

    if (locale !== this.props.locale) {
      // In order to skip transition when changing from RTL to LTR
      this.setState({ isReady: false }, () => {
        requestAnimationFrame(() => this.setState({ isReady: true }));
      });
    }

    if (isOpen && !this.props.isOpen) {
      document.documentElement.style.overflow = 'hidden';

      if (this.drawer) {
        this.drawer.scrollTo({ top: 0, behavior: 'instant' });
      }
    }

    if (!isOpen && this.props.isOpen) {
      document.documentElement.style.overflow = '';
    }
  }

  componentWillUnmount() {
    document.documentElement.style.overflow = '';
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
    }
  }

  render() {
    const { isOpen, title, onClose, children } = this.props;

    return (
      <div
        className={cx(styles.drawer, {
          [styles.opened]: isOpen,
          [styles.ready]: this.state.isReady
        })}
      >
        <div className={styles.backdrop} onClick={onClose} />
        <div
          className={styles.content}
          ref={(node) => {
            this.drawer = node;
          }}
        >
          <div className={styles.header}>
            <p className={styles.title}>{title}</p>
            <span
              className={cx(styles.closeButton, 'modal-close-button')}
              onClick={onClose}
            >
              <span className={cx('icon icon-close')} />
            </span>
          </div>
          {children}
        </div>
      </div>
    );
  }
}

Drawer.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  locale: PropTypes.string
};

const mapStateToProps = (state) => ({
  locale: state.lang.locale
});

export default connect(mapStateToProps)(Drawer);
